import { articleFlavorsSlice } from "./articleFlavorsSlice";
import * as actions from "./articleFlavorsActions";
import * as selectors from "./articleFlavorsSelectors";

export { actions };
export { selectors };
export default articleFlavorsSlice.reducer;
